// Шторка «основная модель перегружена — переключили на резервную».
//
// Распознавание — один запрос, и до ответа приложение не знает, что творится
// на сервере. Поэтому запросу даётся номер (job, уходит в query или в тело), а
// пока ждём — раз в 2 секунды спрашиваем POST /ai/progress, у какой он модели.
// Спрашивать начинаем через 4 секунды: Gemini почти всегда отвечает раньше, и
// в обычный день опроса нет вовсе. Увидели резервную — показываем шторку
// (AiFallbackSheet.vue в App.vue) и больше не спрашиваем.
//
// POST, а не GET: GET-ответы /api сервис-воркер складывает в кэш, и каждый
// номер оставлял бы там запись навсегда.
import { ref } from 'vue'
import api from '../services/api.js'

// null — шторки нет; { reason: 'failover' | 'bypass' } — запрос у резервной
export const aiFallbackNotice = ref(null)

export function newAiJobId() {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  } catch { /* старый WebView без randomUUID */ }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
}

/**
 * Ждём ответа на запрос с номером job. Возвращает stop() — звать, когда
 * ответ пришёл или запрос упал: он гасит опрос и шторку.
 */
export function trackAiJob(job, { startAfterMs = 4000, everyMs = 2000, maxMs = 180000 } = {}) {
  let stopped = false
  let timer = null
  const startedAt = Date.now()

  const tick = async () => {
    if (stopped) return
    try {
      const { data } = await api.post('/ai/progress', { job })
      if (stopped) return
      if (data?.stage === 'fallback') {
        aiFallbackNotice.value = { reason: data.reason || 'failover' }
        return
      }
    } catch { /* опрос — подсказка, его сбой ни на что не влияет */ }
    if (!stopped && Date.now() - startedAt < maxMs) timer = setTimeout(tick, everyMs)
  }
  timer = setTimeout(tick, startAfterMs)

  return () => {
    stopped = true
    clearTimeout(timer)
    aiFallbackNotice.value = null
  }
}

/** Обёртка: номер запросу, опрос на время ожидания, уборка в любом исходе. */
export async function withAiJob(fn) {
  const job = newAiJobId()
  const stop = trackAiJob(job)
  try {
    return await fn(job)
  } finally {
    stop()
  }
}
